export enum DomainTransferStatusEnum {
    Transferrable = 'transferrable',
    NotTransferrable = 'not_transferrable',
    PendingOwner = 'pending_owner',
    PendingAdmin = 'pending_admin',
    PendingRegistry = 'pending_registry',
    Completed = 'completed',
    Cancelled = 'cancelled',
    ServiceUnavailable = 'service_unavailable',
}